module.exports = __webpack_public_path__ + "static/img/flow-icon3.67e123d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flow-icon3.png
// module id = MiTR
// module chunks = 1